import { useEffect, useState } from 'react';
import api from '../lib/api';

const LiveChat = () => {
  const [tawkId, setTawkId] = useState(null);

  useEffect(() => {
    // Fetch Tawk.to property ID from settings
    const fetchSettings = async () => {
      try {
        const response = await api.get('/settings/public');
        if (response.data?.tawk_property_id) {
          setTawkId(response.data.tawk_property_id);
        }
      } catch (error) {
        // Settings not available or chat not configured
        console.log('Live chat not configured');
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    if (!tawkId) return;

    // Load Tawk.to script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://embed.tawk.to/${tawkId}/default`;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    
    document.head.appendChild(script);

    // Customize Tawk.to appearance after load
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    
    // Custom styling to match EchoSense theme
    window.Tawk_API.customStyle = {
      visibility: {
        desktop: {
          position: 'br', // bottom-right
          xOffset: 20,
          yOffset: 20
        },
        mobile: {
          position: 'br',
          xOffset: 10,
          yOffset: 10
        }
      }
    };

    return () => {
      // Cleanup
      const existingScript = document.querySelector(`script[src*="tawk.to"]`);
      if (existingScript) {
        existingScript.remove();
      }
      // Remove Tawk widget
      const tawkWidget = document.getElementById('tawk-widget-container');
      if (tawkWidget) {
        tawkWidget.remove();
      }
    };
  }, [tawkId]);

  return null; // This component doesn't render anything visible
};

export default LiveChat;
